import { useToast } from "@chakra-ui/react";

import {
  ApiImporttasksCreateRequest,
  ImportTaskBroDomainEnum,
  Organisation,
} from "@nens/brostar/openapi-client";

import { getApi } from "@/api/api-configuration";

import { useInvalidateImportTaskListQuery } from "../../../queries/query-import-task";

const api = getApi();

export const useStartImport = () => {
  const invalidateImportTaskList = useInvalidateImportTaskListQuery();
  const toast = useToast();

  const showToast = (title: string, status: "error" | "success" | "info", description?: string) => {
    toast({ title, description, status, duration: 9000, isClosable: true });
  };

  return async (organisation: Organisation) => {
    const createImportTask = async (broDomain: ImportTaskBroDomainEnum) => {
      try {
        const requestParams: ApiImporttasksCreateRequest = {
          data: { broDomain, kvkNumber: organisation.kvkNumber },
        };
        await api.apiImporttasksCreate(requestParams);
      } catch (error) {
        showToast(
          `Import failed for ${broDomain} in ${organisation.name}`,
          "error",
          error instanceof Error ? error.message : "Unknown error"
        );
      }
    };

    showToast(`Starting import for ${organisation.name}. This may take some time.`, "info");

    const results = await Promise.all(Object.values(ImportTaskBroDomainEnum).map(createImportTask));

    // Invalidate the query to trigger a refetch
    await invalidateImportTaskList();

    return results;
  };
};
